import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RedirectLogin from './components/RedirectLogin';
import Login from './pages/Login';
import { AuthProvider } from './components/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './pages/Layout';
import AdminLayout from './pages/AdminLayout';

//student panel
import StudentDashboard from './pages/student/Dashboard';
import StudentAttendance from './pages/student/StudentAttendance';
import StudentNotification from './pages/student/StudentNotification';
import StudentDiary from './pages/student/StudentDiary';
import StudentTimeTable from './pages/student/StudentTimeTable';
import StudentAssignment from './pages/student/StudentAssignment';
import StudentNotes from './pages/student/StudentNotes';
import StudentEvents from './pages/student/StudentEvents';
import StudentHolidays from './pages/student/StudentHolidays';
import AboutInstitute from './pages/student/AboutInstitute';
import StudentProfile from './pages/student/StudentProfile';
import EmergencyContact from './pages/student/EmergencyContact';
import StudentFees from './pages/student/StudentFees';

//Teacher panel
import TeacherDashboard from './pages/teacher/Dashboard';

//Admin panel
import AdminDashboard from './pages/admin/Dashboard';
import SyllabusTrackingReport from './pages/admin/syllabus/SyllabusTrackingReport';
import EnquiryReport from './pages/admin/Enquiry/EnquiryReport';
//Student Enquiry Form
import StudentEnquiryForm from './pages/StudentEnquiryForm';

import axios from 'axios';
import ChapterMaster from './pages/admin/syllabus/ChapterMaster';
import TopicMaster from './pages/admin/syllabus/TopicMaster';
import AddSyllabus from './pages/admin/syllabus/AddSyllabus';

axios.defaults.baseURL = 'https://react-webapp.dds-erp.com/backend';
axios.defaults.withCredentials = true; 

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/MobileAppLogin/mobileForcefullyLogin" element={<RedirectLogin />} />

          <Route path="/" element={<Login />} />
          <Route path="/teacher-login" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Login />} />
          <Route path="/student-login" element={<Login />} />
          <Route path="/student-enquiry-form" element={<StudentEnquiryForm />} />

          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path="/student/dashboard" element={<StudentDashboard />} />
              <Route path="/student/attendance" element={<StudentAttendance />} />
              <Route path="/student/notification" element={<StudentNotification />} />
              <Route path="/student/diary" element={<StudentDiary />} />
              <Route path="/student/timetable" element={<StudentTimeTable />} />
              <Route path="/student/assignment" element={<StudentAssignment />} />
              <Route path="/student/notes" element={<StudentNotes />} />
              <Route path="/student/events" element={<StudentEvents />} />
              <Route path="/student/holidays" element={<StudentHolidays />} />
              <Route path="/student/about-institute" element={<AboutInstitute />} />
              <Route path="/student/profile" element={<StudentProfile />} />
              <Route path="/student/emergency-contact" element={<EmergencyContact />} />
              <Route path="/student/fees" element={<StudentFees />} />
            </Route>
            <Route element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<TeacherDashboard />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />

              <Route path="/admin/chapter-master" element={<ChapterMaster />} />
              <Route path="/admin/topic-master" element={<TopicMaster />} />
              <Route path="/admin/add-syllabus" element={<AddSyllabus />} />
              <Route path="/admin/syllabus-tracking-report" element={<SyllabusTrackingReport />} />
              <Route path="/admin/enquiry-report" element={<EnquiryReport />} />
            </Route>

          </Route>

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
